const state = {
    id: 0,
    code: "",
    name: "",
    category: "OTHER",
    description: "",
    level: "",
    is_repeated: false,
    start_date: "",
    start_time: "",
    end_date: "",
    end_time: "",
    duration: 0,
    status: "",
    type: "",
    repeatitions: [],
    subtests: [],
    is_active: false,
    is_free_access: false,
    created_at: 0,
    updated_at: 0,
    subtestIndex: -1,
    kkm: 0,
};

const mutations = {
    tryout_init: function (state, payload) {
        state.id = payload.id;
        state.code = payload.code;
        state.name = payload.name;
        state.description = payload.description;
        state.level = payload.level;
        state.is_repeated = payload.is_repeated;
        state.start_date = payload.start_date;
        state.start_time = payload.start_time;
        state.end_date = payload.end_date;
        state.end_time = payload.end_time;
        state.duration = payload.duration;
        state.status = payload.status;
        state.type = payload.type;
        state.kkm = payload.kkm;

        var repeatitions = [];
        payload.repeatitions.forEach((element) => {
            repeatitions.push(element.day);
        });

        state.repeatitions = repeatitions;
        state.subtests = payload.subtests;
        state.is_active = payload.is_active;
        state.is_free_access = payload.is_free_access;
        state.created_at = payload.created_at;
        state.updated_at = payload.updated_at;
        state.subtestIndex = -1;
        state.category = payload.category;
    },

    tryout_add_subtest: function (state, payload) {
        var subtest = {
            id: payload.id,
            subject_code: payload.subject_code,
            subject_name: payload.subject_name,
            subject_picture: payload.subject_picture,
            duration: payload.duration,
            item_count: payload.item_count,
            details: payload.details,
            kkm: payload.kkm,
        };

        if (state.subtests == null) state.subtests = [];
        state.subtests.push(subtest);
    },

    tryout_edit_subtest: function (state, payload) {
        var subtest = {
            id: payload.id,
            subject_code: payload.subject_code,
            subject_name: payload.subject_name,
            subject_picture: payload.subject_picture,
            duration: payload.duration,
            item_count: payload.item_count,
            details: payload.details,
            kkm: payload.kkm,
        };

        var index = state.subtestIndex;
        state.subtests[index] = subtest;
    },

    tryout_select_subtest: function (state, subtestIndex) {
        state.subtestIndex = subtestIndex;
    },

    tryout_reset_selected_subtest: function (state) {
        state.subtestIndex = -1;
    },

    tryout_reset: function (state) {
        state.id = 0;
        state.code = "";
        state.name = "";
        state.description = "";
        state.level = "";
        state.is_repeated = false;
        state.start_date = "";
        state.start_time = "";
        state.end_date = "";
        state.end_time = "";
        state.duration = 0;
        state.status = "";
        state.type = "";
        state.repeatitions = [];
        state.subtests = [];
        state.is_active = false;
        state.is_free_access = false;
        state.created_at = 0;
        state.updated_at = 0;
        state.subtestIndex = -1;
        state.category = "OTHER";
        state.kkm = 0;
    },
};

const getters = {
    selectedSubtest: function (state) {
        if (state.subtestIndex < 0) return null;

        return state.subtests[state.subtestIndex];
    },
};

export default { state, mutations, getters };



// WEBPACK FOOTER //
// ./src/modules/tryout/stores/tryout.js